<script setup>
import { watch, ref, onMounted } from 'vue'
import _ from "lodash"

const props = defineProps(['data'])
</script>

<template>
    <section class="breadcrumbs">
        <div class="container">
            <div class="breadcrumbs__list" itemscope itemtype="http://schema.org/BreadcrumbList">
                <div class="breadcrumbs__item" itemscope itemprop="itemListElement" itemtype="http://schema.org/ListItem">
                    <NuxtLink to="/" class="breadcrumbs__link" itemprop="item">
                        <span itemprop="name">Главная</span>
                    </NuxtLink>
                    <meta itemprop="position" content="1"></meta>
                </div>
                <template v-if="data">
                    <li v-for="(crumb, index) in props.data" class="breadcrumbs__item" itemscope="itemscope" itemprop="itemListElement" itemtype="http://schema.org/ListItem" :class="{ last: index === data.length - 1 }">
                        <template v-if="index === data.length - 1">
                            <span class="breadcrumbs__link last" itemprop="name">{{ crumb.name }}</span>
                        </template>
                        <template v-else>
                            <NuxtLink :to="crumb.link" class="breadcrumbs__link" itemprop="item">
                                <span itemprop="name">{{ crumb.name }}</span>
                            </NuxtLink>
                        </template>
                        <meta :content="index + 2" itemprop="position">
                    </li>
                </template>
            </div>
            <!-- <script type="application/ld+json">
                {
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": [{"@type":"ListItem","position":1,"name":"🚀Главная","item":"https://aktivo.ru/"},{"@type":"ListItem","position":2,"name":"🚀Еще какая-то страница","item":"https://aktivo.ru/some-page.html"},{"@type":"ListItem","position":3,"name":"🚀Фонды","item":"https://aktivo.ru/objects-page.html"}]
                }
            </script> -->
        </div>
    </section>
</template>

<style lang="scss" scoped>
.breadcrumbs {
    position: relative;
    height: 54px;
    padding-top: 16px;
    z-index: 1;
    &__list {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow-x: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar {
            display: none;
        }
    }
    &__item {
        position: relative;
        padding-right: 20px;
        margin-right: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:after {
            position: absolute;
            content: '';
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: #6A7784;
            opacity: 0.5;
            top: 50%;
            right: 0;
            transform: translateY(-50%) rotate(45deg);
        }
        &.last {
            &:after {
                display: none;
            }
        }
    }
    &__link {
        position: relative;
        font-size: 12px;
        line-height: 1;
        color: var(--text-color);
        text-decoration: none;
        text-transform: uppercase;
        font-weight: 500;
        transition: all 0.3s ease;
        white-space: nowrap;
        &:hover {
            opacity: 0.7;
        }
        &.last {
            opacity: 0.5;
            pointer-events: none;
            margin-right: 0;
        }
    }
}

@media screen and (min-width: 1360px) {
    .breadcrumbs {
        height: 100px;
        padding-top: 48px;
    }
}

</style>